import { z } from 'zod'

/**
 * These are used for the new homepage, mapped to the urls that are used for results and details
 */

const PRODUCTS = ['flights', 'hotels', 'cars', 'experiences'] as const

export const ProductSlugSchema = z.enum(PRODUCTS)

export type ProductSlug = z.infer<typeof ProductSlugSchema>
